import PropTypes from 'prop-types';
import React from 'react';
import compose from '../hoc/compose';
import defaultSymbol from '../panels/headerHelp-svg.js';
import displayNames from './displayNames';
import Button from './button.js';

var HelpButton = function HelpButton(_ref) {
  var automationId = _ref.automationId,
      dataHook = _ref.dataHook,
      onClick = _ref.onClick,
      symbol = _ref.symbol;
  return /*#__PURE__*/React.createElement(Button, {
    automationId: automationId,
    dataHook: dataHook,
    className: "btn-help btn-header help",
    onClick: onClick
  }, symbol);
};

HelpButton.displayName = displayNames.HELP_BUTTON;
HelpButton.propTypes = {
  onClick: PropTypes.func,
  symbol: PropTypes.element
};
HelpButton.defaultProps = {
  symbol: /*#__PURE__*/React.createElement(defaultSymbol)
};
export default compose(HelpButton);